export const DEFAULT_TABS = [
  {
    name: 'configurations',
    drawer: false, // Direct form, not a CardList drawer
  },
  {
    name: 'approval',
    type: [1, 2, 5, 8], // CompleteInformation, Approval, ExecuteTask, DigitalSignature
    drawer: true,
  },
  // Approval sub-tabs (first level - parent: 'approval')
  {
    name: 'action-approval-general',
    type: [1, 2, 5, 8],
    parent: 'approval',
  },
  {
    name: 'action-approval-rejection',
    type: [1, 2, 8], // Only for CompleteInformation, Approval, DigitalSignature
    parent: 'approval',
  },
  {
    name: 'action-approval-deadline',
    type: [1, 2, 5, 8],
    parent: 'approval',
  },
  {
    name: 'action-approval-filters',
    type: [1, 2, 5, 8],
    drawer: true, // This will show another CardList with filter options
    parent: 'approval',
  },
  // Approval Filters sub-tabs (second level - parent: 'action-approval-filters')
  {
    name: 'action-approval-filters-general',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-users',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-positions',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-areas',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-user-groups',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-external-users',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-agents',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-user-extra-fields',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-global-approvers',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'action-approval-filters-form-field-user-approvers',
    type: [1, 2, 5, 8],
    parent: 'action-approval-filters',
  },
  {
    name: 'custom-notifications',
    field: 'isNotificationsEnabled',
    type: [1, 2],
  },
  {
    name: 'notifications-mapping-attachments',
    field: 'isNotificationsEnabled',
    type: [1, 2],
  },
  {
    name: 'email-template',
    field: 'isNotificationsEnabled',
    type: [1, 2],
  },
  {
    name: 'pdf-template-generation-mapping',
    field: 'isPDFGenerationEnabled',
    type: [1, 2],
  },
  {
    name: 'conditional',
    type: [4],
  },
  {
    name: 'webhook-mapping',
    all: true,
  },
  {
    name: 'action-webhook-general',
    all: true,
  },
  {
    name: 'action-behaviors',
    type: [0, 1],
  },
  {
    name: 'digital-signature-field-mapping',
    type: [6],
    all: true,
  },
  {
    name: 'response-status',
    type: [6],
    all: true,
  },
  {
    name: 'api-call-send',
    type: [6],
    all: true,
  },
  {
    name: 'api-call-response',
    type: [6],
    all: true,
  },
  {
    name: 'set-variable',
    type: [14],
    all: true,
  },
  {
    name: 'set-form-data',
    type: [15],
    all: true,
  },
  {
    name: 'action-entity-operation',
    type: [11], // DynamicEntityOperation
  },
  {
    name: 'action-scheduled-execution',
    type: [18], // ScheduledExecution
  },
  {
    name: 'action-iteration',
    type: [20], // Iterate
  },
  {
    name: 'action-internal-operation',
    type: [22], // InternalOperation
  },
  {
    name: 'action-generate-plain-text-file',
    type: [23], // GeneratePlainTextFile
  },
  {
    name: 'action-import-plain-text-file',
    type: [24], // ImportPlainTextFile
  },
  {
    name: 'action-automy-ai',
    type: [37], // AutomyAI
  },
];
